// extracted by mini-css-extract-plugin
export default {"progressIcon":"SubmitButton_progressIcon__2Cr7l","wide":"SubmitButton_wide__GvX6l","underline":"SubmitButton_underline__N2ogI"};